export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const SELECTED_PRODUCT = 'SELECTED_PRODUCT';
export const PAYMENT_SESSION = 'PAYMENT_SESSION';
export const SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE';
export const SET_BOLD_TOAST_MESSAGE = 'SET_BOLD_TOAST_MESSAGE';
